import React from "react";
const icon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.5 44C25.5 44 40 30.1404 40 19.625C40 15.7462 38.4723 12.0263 35.753 9.28356C33.0338 6.54084 29.3456 5 25.5 5C21.6544 5 17.9662 6.54084 15.247 9.28356C12.5277 12.0263 11 15.7462 11 19.625C11 30.1404 25.5 44 25.5 44ZM25.5 26.9375C23.5772 26.9375 21.7331 26.1671 20.3735 24.7957C19.0138 23.4244 18.25 21.5644 18.25 19.625C18.25 17.6856 19.0138 15.8256 20.3735 14.4543C21.7331 13.0829 23.5772 12.3125 25.5 12.3125C27.4228 12.3125 29.2669 13.0829 30.6265 14.4543C31.9862 15.8256 32.75 17.6856 32.75 19.625C32.75 21.5644 31.9862 23.4244 30.6265 24.7957C29.2669 26.1671 27.4228 26.9375 25.5 26.9375Z"
      fill="url(#paint0_linear_1638_2)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1638_2"
        x1="11"
        y1="21"
        x2="40"
        y2="21"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9F06E6" />
        <stop offset="1" stopColor="#8B03E9" />
      </linearGradient>
    </defs>
  </svg>
);

export default icon;
